<div
  class="sana-video-container">

  <div class="video-wrapper">
    <video
        #videoEl
        playsinline
        preload="metadata"
        class="sana-video"
        crossorigin="anonymous"
        controls="controls"
    >
      @if (vttPath()) {
        <track
            #trackEl
            kind="metadata"
            label="Markers"
            [src]="vttPath()"
            default
        />
      }
    </video>
  </div>
</div>
